
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/* ======================================== */
/* 6.  ATTRIBUTION INSIGHTS                 */
/* ======================================== */
export const AttributionInsights = () => {
  const channels = [
    { name: "Email", value: 38, color: "#8b5cf6" },
    { name: "SMS", value: 26, color: "#06b6d4" },
    { name: "WhatsApp", value: 19, color: "#3b82f6" },
    { name: "Push", value: 17, color: "#f97316" },
  ];
  const bg = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");
  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>
        Attribution Insights
      </Heading>
      <Box h="220px">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={channels}
              innerRadius={40}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
            >
              {channels.map((c) => (
                <Cell key={c.name} fill={c.color} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};